import React, { useState } from "react";
import { MicNone } from "@material-ui/icons";
import { API } from "../../../../../shared/services";
import { useContactsState } from "../../../contexts";
import { toast } from "react-toastify";
import { Button } from "@material-ui/core";
import { ModalRecordAudio } from "./ModalRecordAudio";
import { ModalConfirmAudio } from "./ModalConfirmAudio";
import { useTranslation } from "react-i18next";

let chunks = [];

function getBase64(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = function () {
      resolve(reader.result);
    };

    reader.onerror = function (error) {
      reject(error);
    };
  });
}

export default function AudioAttachment({
  replySources,
  answerMessage,
  setAnswerMessage,
}) {
  const [mediaRecorder, setMediaRecorder] = useState();
  const { currentContact } = useContactsState();
  const [audioModal, setModalAudio] = useState(false);
  const [confirmAudioModal, setConfirmAudioModal] = useState(false);
  const [audio, setAudio] = useState();
  const { t } = useTranslation();

  async function handleSubmitAudio() {
    try {
      const audioBase64 = await getBase64(audio);
      const audioName = "audio.mp3";

      await API.post(`/customers/${currentContact.id}/messages`, {
        message: {
          body: audioName,
          message_quoted_id: answerMessage?.id,
          file: {
            data: audioBase64,
            filename: audioName,
            is_audio: true,
          },
        },
        reply_sources: replySources,
      });

      toast.success(t("Chat:audio_attachment.success"));
      setAnswerMessage(null);
    } catch (e) {
      toast.error(t("Chat:audio_attachment.error"));
    }
  }

  function handleCancel() {
    setAudio(null);
    setModalAudio(false);
    setConfirmAudioModal(false);

    mediaRecorder &&
      mediaRecorder?.state == "recording" &&
      mediaRecorder.stop();

    setMediaRecorder(null);
  }

  function handleFinishRecord() {
    setModalAudio(false);
    setConfirmAudioModal(true);
    mediaRecorder && mediaRecorder.state == "recording" && mediaRecorder.stop();
  }

  async function handleSendAudio() {
    await handleSubmitAudio();

    setAudio(null);
    setModalAudio(false);
    setConfirmAudioModal(false);

    mediaRecorder && mediaRecorder.state != "inactive" && mediaRecorder.stop();
  }

  function startingRecord() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then(function (stream) {
          const recorder = new MediaRecorder(stream);

          recorder.addEventListener("start", (e) => {
            chunks.length = 0;
          });

          recorder.ondataavailable = (e) => chunks.push(e.data);

          recorder.onstop = function (_e) {
            if (!setMediaRecorder) return;

            setMediaRecorder(false);
            const blob = new Blob(chunks, { type: "audio/webm; codecs=FLAC" });
            setAudio(blob);
          };

          recorder.start();

          setMediaRecorder(recorder);
          setModalAudio(true);
        })
        .catch(() => toast.error("Erro ao gravar o áudio"));
    }

    return () => {
      if (mediaRecorder && mediaRecorder.state != "inactive") {
        mediaRecorder.stop();
      }
    };
  }

  return (
    <>
      {audioModal && (
        <ModalRecordAudio
          mediaRecorder={mediaRecorder}
          showModal={audioModal}
          handleCancel={handleCancel}
          handleConfirm={handleFinishRecord}
        />
      )}

      {confirmAudioModal && (
        <ModalConfirmAudio
          showModal={confirmAudioModal}
          handleCancel={handleCancel}
          handleConfirm={handleSendAudio}
          audio={audio}
        />
      )}

      <Button variant="text" component="label" onClick={startingRecord}>
        <MicNone />
      </Button>
    </>
  );
}
